import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from '~/scopes/auth/route-names'

import { CHECKOUT } from './routes-names'

export default (): RouteRecordRaw[] => {
  return [
    {
      path: 'checkout/in-store/bouygues-telecom/:magicLinkId',
      name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.SELF,
      redirect: { name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.CART },
      component: () =>
        import(
          './flows/bouygues-in-store/layout/BouyguesMagicLinkLayout/BouyguesMagicLinkLayout.vue'
        ),
      meta: {
        owners: ['bot-squad-b2cservices-front'],
        layout: false,
      },
      children: [
        {
          path: 'cart',
          name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.CART,
          component: () =>
            import('./flows/bouygues-in-store/pages/CartStep/CartStep.vue'),
        },
        {
          path: 'address-edition',
          name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.ADDRESSES,
          component: () =>
            import(
              './flows/bouygues-in-store/pages/AddressesStep/AddressesStep.vue'
            ),
        },
        {
          path: 'payment',
          name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.PAYMENT,
          component: () =>
            import(
              './flows/bouygues-in-store/pages/PaymentStep/PaymentStep.vue'
            ),
        },
      ],
    },
    {
      path: 'f2',
      name: CHECKOUT.SELF,
      component: () =>
        import('./flows/e-commerce/layout/CheckoutFlow/CheckoutFlow.vue'),
      redirect: { name: CHECKOUT.CART },
      meta: {
        owners: ['bot-squad-checkout-front'],
        layout: false,
      },
      children: [
        {
          name: CHECKOUT.CART,
          path: 'cart',
          component: () =>
            import('./flows/e-commerce/pages/CartStep/CartStep.vue'),
          meta: {
            owners: ['bot-squad-checkout-front'],
            gtmStepId: 1,
          },
        },
        {
          path: 'addresses',
          name: CHECKOUT.ADDRESSES,
          component: () =>
            import('./flows/e-commerce/pages/AddressesStep/AddressesStep.vue'),
          meta: {
            owners: ['bot-squad-checkout-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
            gtmStepId: 4,
          },
        },
        {
          path: 'shipping/billing-address',
          name: CHECKOUT.BILLING_ADDRESS,
          component: () =>
            import(
              './flows/e-commerce/pages/BillingAddressStep/BillingAddressStep.vue'
            ),
          meta: {
            owners: ['bot-squad-checkout-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
            gtmStepId: 5,
          },
        },
        {
          path: 'shipping/shipping-address',
          name: CHECKOUT.SHIPPING_ADDRESS,
          component: () =>
            import(
              './flows/e-commerce/pages/ShippingAddressStep/ShippingAddressStep.vue'
            ),
          meta: {
            owners: ['bot-squad-checkout-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
            gtmStepId: 4,
          },
        },
        {
          path: 'shipping/confirmation-address',
          name: CHECKOUT.ADDRESS_CONFIRMATION,
          component: () =>
            import(
              './flows/e-commerce/pages/AddressConfirmationStep/AddressConfirmationStep.vue'
            ),
          meta: {
            owners: ['bot-squad-checkout-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
            gtmStepId: 4,
          },
        },
        {
          path: 'services/bouygues-telecom',
          name: CHECKOUT.SERVICES.BOUYGUES.ROOT,
          redirect: { name: CHECKOUT.SERVICES.BOUYGUES.SIGN_UP },
          meta: {
            owners: ['bot-squad-b2cservices-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
          },
          children: [
            {
              path: 'sign-up',
              name: CHECKOUT.SERVICES.BOUYGUES.SIGN_UP,
              component: () =>
                import(
                  './flows/e-commerce/pages/BouyguesSignUp/BouyguesSignUp.vue'
                ),
              meta: {
                owners: ['bot-squad-b2cservices-front'],
              },
            },
            {
              path: 'phoneline-setup',
              name: CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP,
              component: () =>
                import(
                  './flows/e-commerce/pages/BouyguesPhonelineSetup/BouyguesPhonelineSetup.vue'
                ),
              meta: {
                owners: ['bot-squad-b2cservices-front'],
              },
            },
            {
              path: 'not-eligible',
              name: CHECKOUT.SERVICES.BOUYGUES.NOT_ELIGIBLE,
              component: () =>
                import(
                  './flows/e-commerce/pages/BouyguesPhonelineSetup/components/NotEligible/NotEligible.vue'
                ),
              meta: {
                owners: ['bot-squad-b2cservices-front'],
              },
            },
          ],
        },
        {
          path: 'payment',
          name: CHECKOUT.PAYMENT,
          component: () =>
            import('./flows/e-commerce/pages/PaymentStep/PaymentStep.vue'),
          meta: {
            owners: ['bot-squad-checkout-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
            payment: {
              contentSecurityPoliciesEnabled: true,
            },
            gtmStepId: 6,
          },
        },
      ],
    },
    {
      path: 'checkout/gift-cards/:requestId',
      name: CHECKOUT.GIFT_CARDS.SELF,
      component: () =>
        import('./flows/gift-card/layout/GiftCardFlow/GiftCardFlow.vue'),
      redirect: { name: CHECKOUT.GIFT_CARDS.BILLING_ADDRESS },
      meta: {
        owners: ['bot-squad-b2cservices-front'],
        layout: false,
        auth: {
          required: true,
          redirection: { name: ROUTES.AUTH.LOGIN },
        },
      },
      children: [
        {
          path: 'billing-address',
          name: CHECKOUT.GIFT_CARDS.BILLING_ADDRESS,
          component: () =>
            import(
              './flows/gift-card/pages/BillingAddressStep/BillingAddressStep.vue'
            ),
          meta: {
            owners: ['bot-squad-b2cservices-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
          },
        },
        {
          path: 'payment',
          name: CHECKOUT.GIFT_CARDS.PAYMENT,
          component: () =>
            import('./flows/gift-card/pages/PaymentStep/PaymentStep.vue'),
          meta: {
            owners: ['bot-squad-b2cservices-front'],
            auth: {
              required: true,
              redirection: { name: ROUTES.AUTH.LOGIN },
            },
            payment: {
              contentSecurityPoliciesEnabled: true,
            },
          },
        },
        {
          path: 'webview',
          redirect: { name: CHECKOUT.GIFT_CARDS.WEBVIEW.BILLING_ADDRESS },
          children: [
            {
              path: 'billing-address',
              name: CHECKOUT.GIFT_CARDS.WEBVIEW.BILLING_ADDRESS,
              component: () =>
                import(
                  './flows/gift-card/pages/BillingAddressStep/BillingAddressStep.vue'
                ),
              meta: {
                owners: ['bot-squad-b2cservices-front'],
                auth: {
                  required: true,
                  redirection: { name: ROUTES.AUTH.LOGIN },
                },
              },
            },
            {
              path: 'payment',
              name: CHECKOUT.GIFT_CARDS.WEBVIEW.PAYMENT,
              component: () =>
                import('./flows/gift-card/pages/PaymentStep/PaymentStep.vue'),
              meta: {
                owners: ['bot-squad-b2cservices-front'],
                auth: {
                  required: true,
                  redirection: { name: ROUTES.AUTH.LOGIN },
                },
              },
            },
          ],
        },
      ],
    },
    {
      path: 'f2/payment-result/:paymentId?',
      name: CHECKOUT.PAYMENT_RESULT,
      component: () => import('./pages/Result/Result.vue'),
      meta: {
        owners: ['bot-squad-checkout-front'],
        auth: {
          required: true,
          redirection: { name: ROUTES.AUTH.LOGIN },
        },
      },
    },
    {
      path: 'checkout/in-store/bouygues-telecom/:magicLinkId/payment-result/:paymentId?',
      name: CHECKOUT.IN_STORE_SALES.BOUYGUES_TELECOM.PAYMENT_RESULT,
      component: () => import('./pages/Result/Result.vue'),
      meta: {
        owners: ['bot-squad-checkout-front'],
        auth: {
          required: true,
          redirection: { name: ROUTES.AUTH.LOGIN },
        },
      },
    },
    {
      path: 'f2/services/bouygues-telecom/auth',
      name: CHECKOUT.SERVICES.BOUYGUES.AUTH,
      component: () =>
        import(
          './flows/e-commerce/pages/BouyguesAuthentication/BouyguesAuthentication.vue'
        ),
      meta: {
        layout: 'minimal',
        owners: ['bot-squad-b2cservices-front'],
      },
    },
    {
      path: 'checkout/gift-card/:requestId/payment-result',
      name: CHECKOUT.GIFT_CARDS.PAYMENT_RESULT,
      component: () => import('./pages/GiftCardsResults/GiftCardsResults.vue'),
      meta: {
        owners: ['bot-squad-b2cservices-front'],
        auth: {
          required: true,
        },
      },
    },
  ]
}
